import { render, staticRenderFns } from "./CartBook.vue?vue&type=template&id=3802501d"
import script from "./CartBook.vue?vue&type=script&lang=ts"
export * from "./CartBook.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports